/**
 * Carousel data processor (set via data-carousel-options in ftl)
 *
 *
 * @type {{}}
 */
module.exports = {

    /**
     *
     * @param $carousel
     * @return {*}
     */
    getCarouselData: function getCarouselData($carousel) {
        var data = $carousel.data('carouselOptions');

        // If we have invalid JSON in ftl and cannot proceed or we don't have carousel options set at all (full default)
        if (typeof data === 'string') {
            return {};
        }
        return data || {};
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/carousel-data.js
// module id = 39
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17